import Vue from 'vue'
import VueRouter from 'vue-router'
import HelloWorld from '../components/HelloWorld.vue'
import RecordView from '../view/RecordView.vue'
import RecordSocialServiceView from '../view/RecordSocialServiceView.vue'
import RecordLanguageReleaseView from '../view/RecordLanguageReleaseView.vue'
import RecordExchangeValidationView from '../view/RecordExchangeValidationView.vue'
import DigitalDegreeView from '../view/DigitalDegreeView.vue'
import NotFound from '../view/NotFound.vue'
import DatosQR from '../view/DatosQR.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HelloWorld,
  },
  {
    path: '/tramites-validacion-qr/procedures/record',
    name: 'record',
    component: RecordView,
  },
  {
    path: '/tramites-validacion-qr/procedures/record_social_service',
    name: 'record_social_service',
    component: RecordSocialServiceView,
  },
  {
    path: '/tramites-validacion-qr/procedures/record_language_release',
    name: 'record_language_release',
    component: RecordLanguageReleaseView,
  },
  {
    path: '/tramites-validacion-qr/procedures/record_exchange_validation',
    name: 'record_exchange_validation',
    component: RecordExchangeValidationView,
  },
  {
    path: '/tramites-validacion-qr/procedures/digital_degree',
    name: 'digital_degree',
    component: DigitalDegreeView,
  },
  { 
    path: '/404', 
    name: 'not_found',
    component: NotFound
  },  
  { 
    path: '*', 
    redirect: '/404' 
  },
  {
    path: '/datosQR/api/qr',
    name: 'datos_qr',
    component: DatosQR
  },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  routes
})

export default router